var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnd)?_c('div',{staticClass:"end-line"},[_c('div',{staticClass:"end-line-text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }